/**
 * stripReadOnlyForUpdate — build a deal child-entity PUT body from the panel's
 * edited row by dropping the fields the `*UpdateRequest` models reject.
 *
 * The metadata-driven CRUD panels hand `onUpdate` the whole row, which carries
 * server-managed columns (`id`, `created_by`/`created_at`, `updated_by`/
 * `updated_at`), the immutable single-table parent FK (`deal_id`,
 * `lease_deed_id`, `well_id`, `well_tract_id`), and generated columns
 * (`legalstr`). Every child update model is `extra="forbid"`, so sending any of
 * those returns 422 — the "add works but editing an existing row fails" bug
 * (UAT #26 and the same pattern across every child tab).
 *
 * Polymorphic parents (`parent_table` / `parent_id`, used by payments/remarks)
 * ARE updatable, so they are intentionally kept.
 *
 * @param {Record<string, unknown>} body  the panel's edited row
 * @returns {Record<string, unknown>}      body without read-only/immutable fields
 */
const READ_ONLY_UPDATE_FIELDS = new Set([
  "id",
  "created_by",
  "created_at",
  "updated_by",
  "updated_at",
  // immutable single-table parent FKs (each child update model forbids
  // re-parenting; polymorphic parent_table/parent_id are NOT listed)
  "deal_id",
  "lease_deed_id",
  "well_id",
  "well_tract_id",
  // generated column carried on lease_deed_tracts rows
  "legalstr",
]);

export const stripReadOnlyForUpdate = (body) => {
  const out = {};
  for (const [k, v] of Object.entries(body || {})) {
    if (!READ_ONLY_UPDATE_FIELDS.has(k)) out[k] = v;
  }
  return out;
};

export default stripReadOnlyForUpdate;
